export function sqlSafe(str) {
  return str.replaceAll("'", "''")
}

export function sqlUnsafe(str) {
  return str.replaceAll("''", "'")
}